import React, { useState } from 'react';
import api from '../api'; // Importa a instância do Axios
import { jwtDecode } from 'jwt-decode'; // Para decodificar o token
import '../styles/anexoPdf.scss';

const AnexoPDF = () => {
    const [polo, setPolo] = useState('');
    const [mes, setMes] = useState('');
    const [ano, setAno] = useState(2025);
    const [pdfs, setPDFs] = useState([]);
    const [files, setFiles] = useState([]);

    // Função para capturar o ID do usuário a partir do token
    const getUserId = () => {
        const token = localStorage.getItem('token');
        if (token) {
            const decoded = jwtDecode(token);
            return decoded.id; // Certifique-se de que o campo está correto
        }
        return null;
    };

    const handleFileChange = (e) => {
        setFiles(e.target.files);
    };

    const handleUpload = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('polo', polo);
        formData.append('mes', mes);
        formData.append('ano', ano);
        formData.append('userId', getUserId()); // Adiciona o ID do usuário ao FormData

        for (let i = 0; i < files.length; i++) {
            formData.append('pdfs', files[i]);
        }

        try {
            const response = await api.post('/anexar', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            // Verifica se a resposta foi bem-sucedida
            if (response.status !== 201) {
                throw new Error(`Erro: ${response.statusText}`);
            }

            alert('PDFs Anexados com sucesso!');
            handleVisualizar();
            // setFiles([]);
            // setPolo('');
            // setMes('');
        } catch (error) {
            alert('Erro ao anexar PDFs: ' + error.message);
        }
    };

    const handleVisualizar = async () => {
        try {
            const response = await api.get(`/visualizar/${polo}/${mes}/${ano}`);

            // Verifique se a resposta contém dados
            if (response.data && response.data.length > 0) {
                const pdfsList = response.data;
                console.log(pdfsList); // Verifique os dados retornados
                setPDFs(pdfsList);
            } else {
                throw new Error('Nenhum PDF encontrado'); // Lança erro se não houver PDFs
            }
        } catch (error) {
            alert('Erro ao visualizar PDFs: ' + error.message);
        }
    };




    const handleDownload = async (id, index) => {
        try {
            const response = await api.get(`/download/${id}/${index}`, { responseType: 'blob' });

            // Não precisamos verificar response.ok, pois estamos usando Axios
            if (response.status !== 200) {
                throw new Error('Falha ao baixar o PDF');
            }

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = `PDF_${id}_${index}.pdf`; // Define o nome do arquivo com o ID e índice
            document.body.appendChild(link); // Necessário para Firefox
            link.click();
            document.body.removeChild(link); // Remove o link após o clique

            // Opcional: liberar o objeto URL após o download
            URL.revokeObjectURL(url);
        } catch (error) {
            alert('Erro ao baixar PDF: ' + error.message);
        }
    };

    const handleDelete = async (id, index) => {
        const confirmDelete = window.confirm('Você tem certeza que deseja excluir este PDF?');

        if (!confirmDelete) return; // Se o usuário cancelar, não faz nada

        try {
            const response = await api.delete(`/excluir/${id}/${index}`); // Chama a API para excluir o PDF

            if (response.status === 200) {
                alert('PDF excluído com sucesso!');
                // Atualizar a lista de PDFs após a exclusão (pode ser necessário fazer um fetch novamente)
                handleVisualizar(); // Chame a função que você usa para buscar a lista de PDFs
            }
        } catch (error) {
            alert('Erro ao excluir PDF: ' + error.message);
        }
    };






    return (
        <>
            <div className="container">
                <div className="anexoPDF">
                    <h1>Anexar PDFs</h1>
                    <form onSubmit={handleUpload} className='anexo-upload'>
                        <label>
                            Polo:
                            <select value={polo} onChange={(e) => setPolo(e.target.value)}>
                                <option value="">Selecione</option>
                                <option value="Polo 0001">Polo 0001</option>
                                <option value="Polo 0009">Polo 0009</option>
                                <option value="Polo 0013">Polo 0013</option>
                                <option value="Polo 0016">Polo 0016</option>
                                <option value="Polo 0026">Polo 0026</option>
                                <option value="Polo 0032">Polo 0032</option>
                                <option value="Polo 0033">Polo 0033</option>
                                <option value="Polo 0038">Polo 0038</option>
                                <option value="Polo 0041">Polo 0041</option>
                                <option value="Polo 0045">Polo 0045</option>
                                <option value="Polo 0046">Polo 0046</option>
                                <option value="Polo 0063">Polo 0063</option>
                                <option value="Polo 0071">Polo 0071</option>
                                <option value="Polo 0117">Polo 0117</option>
                                <option value="Polo 0135">Polo 0135</option>
                                <option value="Polo 0155">Polo 0155</option>
                                <option value="Polo 0175">Polo 0175</option>
                                <option value="Polo 0198">Polo 0198</option>
                                <option value="Polo 0242">Polo 0242</option>
                                <option value="Polo 0247">Polo 0247</option>
                                <option value="Polo 0249">Polo 0249</option>
                                <option value="Polo 0250">Polo 0250</option>
                            </select>
                        </label>
                        <label>
                            Mês:
                            <select value={mes} onChange={(e) => setMes(e.target.value)}>
                                <option value="">Selecione</option>
                                <option value="Janeiro">Janeiro</option>
                                <option value="Fevereiro">Fevereiro</option>
                                <option value="Março">Março</option>
                                <option value="Abril">Abril</option>
                                <option value="Maio">Maio</option>
                                <option value="Junho">Junho</option>
                                <option value="Julho">Julho</option>
                                <option value="Agosto">Agosto</option>
                                <option value="Setembro">Setembro</option>
                                <option value="Outubro">Outubro</option>
                                <option value="Novembro">Novembro</option>
                                <option value="Dezembro">Dezembro</option>
                            </select>
                        </label>
                        <label>
                            Ano:
                            <select value={ano} onChange={(e) => setAno(e.target.value)} required>
                                {(() => {
                                    const currentYear = new Date().getFullYear();
                                    return (
                                        <>
                                            <option value={currentYear}>{currentYear}</option>
                                            <option value={currentYear - 1}>{currentYear - 1}</option>
                                        </>
                                    );
                                })()}
                            </select>
                        </label>
                        <label>
                            PDFs:
                            <input type="file" multiple accept=".pdf" onChange={handleFileChange} required />
                        </label>
                        <div className="button-group">
                            <button type="submit">Anexar PDFs</button>
                            <button type="button" onClick={handleVisualizar}>Visualizar PDFs</button>
                        </div>
                    </form>
                </div>
                <div className="anexo-visualizar">
                    <h1>Visualizar PDFs</h1>
                    <div className="pdfList">
                        {
                            pdfs.length > 0 ? (
                                pdfs.map((pdf, index) => (
                                    <div key={pdf.id}>
                                        <span>{pdf.name}</span>
                                        <br />
                                        <button className='btn-download' onClick={() => handleDownload(pdf.id, index)}>Download</button>
                                        <button className='btn-excluir' onClick={() => handleDelete(pdf.id, index)}>❌</button> {/* Botão para excluir */}
                                    </div>
                                ))
                            ) : (
                                <p>Selecione o Polo, Mês e ano para visualizar PDFs</p>
                            )
                        }
                    </div>
                </div>

            </div>
        </>
    );


};

export default AnexoPDF;
